// extracted by mini-css-extract-plugin
module.exports = {"noBr":"Paragraph-module--noBr--3MmcV","paragraph":"Paragraph-module--paragraph--1MZ3N","mobile":"Paragraph-module--mobile--xfuyl"};